<template>
  <default-modal
    ref="box"
    :title="title"
    :modalWidth="600"
    :confirmTxt="confirmText"
    @confirm="confirm"
  >
    <div class="modal-body">
      <div>
        <div class="row">
          <img
            src="@/assets/img/icon/u1280.svg"
            alt=""
          />是否删除任务“<span v-text="taskName"></span>” ?
        </div>
        <div class="tips">
          提示：该操作将自动删除已下发到网吧的服务器或客户机任务文件。
        </div>
      </div>
    </div>
  </default-modal>
</template>
<script>
import DefaultModal from "_c/modals/defaultModal";
import { delTask } from "@/requests/threeTierMission";
export default {
  components: {
    DefaultModal,
  },
  props: {
    total: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      taskId: "",
      taskName: "",
      title: "删除任务",
      confirmText: "",
      successFn: "",
    };
  },
  mounted() {
    window.$modal.delTasksModal = {};
    window.$modal.delTasksModal.show = (id, taskName) => {
      this.taskId = id;
      this.taskName = taskName;
      this.confirmText = "确定";
      return new Promise((resolve) => {
        this.init(() => {
          resolve(true);
        });
      });
    };
    //监听键盘按键事件
    let self = this;
    this.$nextTick(function () {
      document.addEventListener('keyup', function (e) {
        //此处填写你的业务逻辑即可
        if (e.keyCode == 27) {
          self.$refs.box.hide();
        }
      })
    })
  },
  methods: {
    // 初始化信息
    init(fn) {
      this.$refs.box.show();
      this.successFn = fn;
    },
    async confirm() {
      let resValue = await delTask({
        taskId: this.taskId,
      });
      if (resValue.code == 200) {
        this.$refs.box.hide();
        this.successFn();
      } else {
        this.$refs.box.setWrong(resValue.msg);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.modal-body {
  padding: 10px 0 10px 50px;
  text-align: left;
  .row {
    height: 40px;
  }
  .tips {
    margin-left: 28px;
    font-size: 12px;
    color: rgb(217, 0, 27);
  }
  img {
    position: relative;
    top: 5px;
    margin-right: 8px;
  }
}
</style>
